"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _mobxReact = require("mobx-react");
var _mobx = require("mobx");
var _state = require("@seedlang/state");
var _constants = require("@seedlang/constants");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
function faqScreenIds(props) {
  var _props$params$faqItem, _props$params, _props$route, _props$params$faqCate, _props$params2, _props$route2;
  return {
    faqItemId: (_props$params$faqItem = (_props$params = props.params) === null || _props$params === void 0 ? void 0 : _props$params.faqItemId) !== null && _props$params$faqItem !== void 0 ? _props$params$faqItem : (_props$route = props.route) === null || _props$route === void 0 || (_props$route = _props$route.params) === null || _props$route === void 0 ? void 0 : _props$route.faqItemId,
    faqCategoryId: (_props$params$faqCate = (_props$params2 = props.params) === null || _props$params2 === void 0 ? void 0 : _props$params2.faqCategoryId) !== null && _props$params$faqCate !== void 0 ? _props$params$faqCate : (_props$route2 = props.route) === null || _props$route2 === void 0 || (_props$route2 = _props$route2.params) === null || _props$route2 === void 0 ? void 0 : _props$route2.faqCategoryId
  };
}
var FaqItemShowWrapper = function FaqItemShowWrapper(Component) {
  var _class, _class2, _descriptor, _descriptor2;
  return (0, _mobxReact.observer)(_class = (_class2 = /*#__PURE__*/function (_React$Component) {
    function _class2() {
      var _this;
      _classCallCheck(this, _class2);
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }
      _this = _callSuper(this, _class2, [].concat(args));
      _this.focusListener = null;
      _this.faqItemRequestId = 0;
      _initializerDefineProperty(_this, "isLoading", _descriptor, _this);
      _initializerDefineProperty(_this, "loadFailed", _descriptor2, _this);
      _this.loadFaqData = function () {
        var _faqScreenIds = faqScreenIds(_this.props),
          faqItemId = _faqScreenIds.faqItemId,
          faqCategoryId = _faqScreenIds.faqCategoryId;
        if (!faqItemId) {
          return;
        }
        var requestId = ++_this.faqItemRequestId;
        _this.isLoading = true;
        _this.loadFailed = false;
        _state.AppUI.faqItemStore.clearShowData();
        _state.ForumUI.forumThreadStore.clearShowData();
        _state.AppUI.faqItemStore.getShow({
          ids: {
            faqItemId: faqItemId
          }
        }, function (response) {
          return _this.afterGetFaqItem(requestId, response);
        }, {
          timeout: _constants.Constants.FAQ_REQUEST_TIMEOUT,
          failureCallback: function failureCallback() {
            return _this.handleLoadFailure(requestId);
          },
          onRequestError: function onRequestError() {
            return _this.handleLoadFailure(requestId);
          }
        });
        if (faqCategoryId) {
          _state.AppUI.faqCategoryStore.getShow({
            ids: {
              faqCategoryId: faqCategoryId
            }
          }, null, {
            timeout: _constants.Constants.FAQ_REQUEST_TIMEOUT
          });
        }
      };
      _this.afterGetFaqItem = function (requestId, resp) {
        if (requestId !== _this.faqItemRequestId) {
          return;
        }
        _state.AppUI.faqItemStore.setShowData(resp);
        _this.isLoading = false;
        if (_this.faqItem.forumThreadId) {
          _this.loadForumThread(_this.faqItem.forumThreadId);
        }
      };
      _this.handleLoadFailure = function (requestId) {
        if (requestId === _this.faqItemRequestId) {
          _this.isLoading = false;
          _this.loadFailed = true;
        }
      };
      _this.loadForumThread = function (id) {
        _state.ForumUI.forumThreadStore.getShow({
          ids: {
            forumThreadId: id
          }
        }, _this.afterLoadForumThread);
      };
      _this.afterLoadForumThread = function (resp) {
        _state.ForumUI.forumThreadStore.setShowData(resp);
      };
      _this.afterEmbeddedCommentCreate = function () {
        _this.loadForumThread(_this.faqItem.forumThreadId);
      };
      return _this;
    }
    _inherits(_class2, _React$Component);
    return _createClass(_class2, [{
      key: "faqItem",
      get: function get() {
        return _state.AppUI.faqItemStore.showData;
      }
    }, {
      key: "forumThread",
      get: function get() {
        return _state.ForumUI.forumThreadStore.showData;
      }
    }, {
      key: "showSpinner",
      get: function get() {
        return _state.ForumUI.forumThreadStore.hasOutstandingRequests;
      }
    }, {
      key: "componentDidMount",
      value: function componentDidMount() {
        if (this.props.navigation) {
          this.focusListener = this.props.navigation.addListener('focus', this.loadFaqData);
        } else {
          this.loadFaqData();
        }
      }
    }, {
      key: "componentDidUpdate",
      value: function componentDidUpdate(prevProps) {
        var prevFaqItemId = faqScreenIds(prevProps).faqItemId;
        var nextFaqItemId = faqScreenIds(this.props).faqItemId;
        if (prevFaqItemId !== nextFaqItemId) {
          this.loadFaqData();
        }
      }
    }, {
      key: "componentWillUnmount",
      value: function componentWillUnmount() {
        this.faqItemRequestId += 1;
        if (this.focusListener) {
          this.focusListener();
        }
      }
    }, {
      key: "render",
      value: function render() {
        return /*#__PURE__*/_react["default"].createElement(Component, _extends({}, this.props, {
          faqItem: this.faqItem,
          faqCategory: _state.AppUI.faqCategoryStore.showData,
          forumThread: this.forumThread,
          afterEmbeddedCommentCreate: this.afterEmbeddedCommentCreate,
          showSpinner: this.showSpinner,
          isLoading: this.isLoading,
          loadFailed: this.loadFailed,
          retryLoad: this.loadFaqData
        }));
      }
    }]);
  }(_react["default"].Component), _descriptor = _applyDecoratedDescriptor(_class2.prototype, "isLoading", [_mobx.observable], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function initializer() {
      return false;
    }
  }), _descriptor2 = _applyDecoratedDescriptor(_class2.prototype, "loadFailed", [_mobx.observable], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function initializer() {
      return false;
    }
  }), _applyDecoratedDescriptor(_class2.prototype, "faqItem", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "faqItem"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "forumThread", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "forumThread"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "showSpinner", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "showSpinner"), _class2.prototype), _class2)) || _class;
};
FaqItemShowWrapper.displayName = 'FaqItemShowWrapper';
var _default = exports["default"] = FaqItemShowWrapper;